import { useMutation } from '@tanstack/react-query';
import { notification } from 'antd';

import { axiosInstance } from '../../../axios/axiosInstance';
import { PaymentPayload } from '../../model/interfaces/PaymentPayload';
import { SubscriptionPayload } from '../../model/interfaces/SubscriptionPayload';

export const useCheckOutPayment = () =>
  useMutation(
    async (payload: PaymentPayload | SubscriptionPayload): Promise<{ redirect_url: string }> => {
      const { data } = await axiosInstance.post('api/payments/checkout', { ...payload });
      return data;
    },
    { onError: () => notification.error({ message: 'Purchase error!' }) },
  );
